import React, { useState, useEffect } from 'react';
import FPS_Dist_Active_Details from './FPS_Dist_Active_Details';  
import { CircularProgress } from '@mui/material';
const FPS_Login_Int = () => {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [currentMonth, setCurrentMonth] = useState('');
    const [currentYear, setCurrentYear] = useState('');
    const [months, setMonths] = useState([]);
    const [years, setYears] = useState([]);
    const [detailsR, setDetailsR] = useState(null);
    const [loadingR, setLoadingR] = useState(false);
    const [showTopButton, setShowTopButton] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadInitialData();
        
        const handleScroll = () => {
            setShowTopButton(window.scrollY > 300);
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const loadInitialData = async () => {
        try {
            setError(null);
            const response = await fetch(`${process.env.REACT_APP_URL_FPS}/api/fps/initial-data`);
            
            if (!response.ok) {
                throw new Error(`Backend error: ${response.status} ${response.statusText}`);
            }
            
            const data = await response.json();
            
            if (!data || typeof data !== 'object') {
                throw new Error('Invalid Request (Exception)');
            }
            
            setMonths(data.months || []);
            setYears(data.years || []);
            setCurrentMonth(data.currentMonth || '');
            setCurrentYear(data.currentYear || '');
            setMonth(data.currentMonth || '');
            setYear(data.currentYear?.toString() || '');
            
            if (data.currentMonth && data.currentYear) {
                detailsRHandler(data.currentMonth, data.currentYear.toString());
            }
        } catch (error) {
            console.error('Error loading initial data:', error);
            setError('Invalid Request (Exception).');
            
            const currentDate = new Date();
            const fallbackMonths = [
                { value: 1, label: 'January' }, { value: 2, label: 'February' },
                { value: 3, label: 'March' }, { value: 4, label: 'April' },
                { value: 5, label: 'May' }, { value: 6, label: 'June' },
                { value: 7, label: 'July' }, { value: 8, label: 'August' },
                { value: 9, label: 'September' }, { value: 10, label: 'October' },
                { value: 11, label: 'November' }, { value: 12, label: 'December' }
            ];
            setMonths(fallbackMonths);
            setYears([currentDate.getFullYear() - 1, currentDate.getFullYear(), currentDate.getFullYear() + 1]);
            setCurrentMonth(currentDate.getMonth() + 1);
            setCurrentYear(currentDate.getFullYear());
            setMonth(currentDate.getMonth() + 1);
            setYear(currentDate.getFullYear().toString());
        }
    };

    const detailsRHandler = async (customMonth = null, customYear = null) => {
        const selectedMonth = customMonth || month;
        const selectedYear = customYear || year;
        
        if (!selectedMonth || !selectedYear) {
            setError('Please select both month and year');
            return;
        }
        
        setLoadingR(true);
        setError(null);
        try {
            const response = await fetch(`${process.env.REACT_APP_URL_FPS}/api/fps/dist-active-details`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    month: selectedMonth, 
                    year: selectedYear 
                }),
            });

            if (!response.ok) {
                throw new Error(`Backend error: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            
            if (!data || typeof data !== 'object') {
                throw new Error('Invalid Request (Exception)');
            }
            
            setDetailsR(data);
        } catch (error) {
            console.error('Error fetching details:', error);
            setError('Invalid Request (Exception)');
            setDetailsR(null);
        } finally {
            setLoadingR(false);
        }
    };

    const goBack = () => {
        window.history.back();
    };

    const handleDrillDown = (drillDownData) => {
        setDetailsR(drillDownData);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div style={{ paddingBottom: '70px' }}>
            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                <table style={{ width: '70%', margin: '0 auto', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr className="tableheader">
                            <th colSpan="8" >
                                FPS Activity
                            </th>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Month</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                <select 
                                    value={month} 
                                    onChange={(e) => setMonth(e.target.value)}
                                    style={{ width: '150px', padding: '5px' }}
                                    dangerouslySetInnerHTML={{ __html: months.join('') }}
                                />
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Year</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                <select 
                                    value={year} 
                                    onChange={(e) => setYear(e.target.value)}
                                    style={{ width: '150px', padding: '5px' }}
                                    dangerouslySetInnerHTML={{ __html: years.join('') }}
                                />
                                <input type="hidden" value={currentMonth} />
                                <input type="hidden" value={currentYear} />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="8" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                                <button 
                                    onClick={() => detailsRHandler()}
                                    className="button button2"
                                >
                                    Submit
                                </button>
                                &nbsp;&nbsp;
                                <button 
                                    onClick={goBack}
                                   className="button button2"
                                >
                                    Back
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {error && (
                <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
          
                     {error}
                </div>
            )}

            {loadingR && (
                <div style={{ textAlign: 'center', marginTop: '20px 0' }}>
                    <CircularProgress/>
                </div>
            )}

            {detailsR && !error && (
                <FPS_Dist_Active_Details 
                    data={detailsR} 
                    onDrillDown={handleDrillDown}
                    onBack={() => setDetailsR(null)}
                />
            )}

            {showTopButton && (
                <button
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        right: '18px',
                        bottom: '18px',
                        zIndex: 9999,
                        backgroundColor: '#f1872bff',
                        color: '#100d0dff',
                        border: 'none',
                        padding: '12px 14px',
                        borderRadius: '20px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '14px'
                    }}
                    title="Back to Top"
                >
                    Top
                </button>
            )}
        </div>
    );
};

export default FPS_Login_Int;
